import script from "./CallMonthly.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallMonthly.vue?vue&type=script&setup=true&lang=ts"

import "./CallMonthly.vue?vue&type=style&index=0&id=2536ca9b&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2536ca9b"]])

export default __exports__